export enum MenuItemIdentifier {
  SubPage = 'wix.members_area.sub_pages.tab',
  SettingsSubPage = 'wix.members_area.settings_sub_pages.tab',
}
